import { Fragment, useMemo } from 'react';
import { VscLoading } from 'react-icons/vsc';
import JobPostTable from './JobPostTable';
import Pagination from '@/components/Admin/Pagination';

const JobPostTableContainer = ({
    teamDetails,
    loading,
    onEdit,
    fetchOnAction,
    data = {},
    currentPage,
    onPageChanged,
}) => {
    const results = useMemo(() => data?.results || [], [data]);
    if (loading) {
        return (
            <h4 className="text-center">
                <VscLoading className="spin" fontSize="42" />
            </h4>
        );
    }
    return (
        <Fragment>
            {results && results.length ? (
                <Fragment>
                    <JobPostTable
                        page={data?.page || 1}
                        limit={data?.limit || 10}
                        results={results}
                        onEdit={onEdit}
                        onArchive={fetchOnAction}
                        teamDetails={teamDetails}
                    />
                    {data.totalResults ? (
                        <div className="m-4">
                            <Pagination
                                pageNo={currentPage}
                                totalRecords={data.totalResults}
                                pageLimit={10}
                                pageNeighbours={1}
                                onPageChanged={onPageChanged}
                            />
                        </div>
                    ) : null}
                </Fragment>
            ) : (
                <div className="text-center mt-4">
                    <h2 className="mt-4 mb-4">No job posts found.</h2>
                </div>
            )}
        </Fragment>
    );
};

export default JobPostTableContainer;
